<template>
  <div class="container">
    <div class="fixed_top1" v-show="fixed_show == 1"></div>
    <div class="fixed_top2" v-show="fixed_show == 2">
      服务热线：13381130566
    </div>
    <div class="header">
      <div class="head_left">
        <div class="logo"></div>
        <div class="row_line"></div>
        <div class="logo_text">CC-1000T智能座舱测评体系</div>
      </div>
      <div class="head_right">
        <div class="head_links">
          <div class="head_link" @click="scrollToView(1)">首页</div>
          <div class="head_link" @click="scrollToView(2)">产品服务</div>
          <div class="head_link" @click="scrollToView(3)">产品优势</div>
          <div class="head_link" @click="scrollToView(4)">合作客户</div>
          <div class="head_link" @click="scrollToView(5)">新闻资讯</div>
        </div>
        <template v-if="loginInfo">
          <router-link to="/home" class="head_login head_logined">进入后台</router-link>
        </template>
        <template v-else>
          <router-link to="/login" class="head_login">登录</router-link>
        </template>
        <div class="head_form" @click="visitShow = true">预约演示</div>
      </div>
    </div>
    <div class="main">
      <div class="section section1">
        <div class="banner">
          <img
            src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/banner.jpg"
          />
        </div>
        <div class="content1">
          <div class="font_27">
            车云CC-1000T智能座舱测评体系致力于汽车业<br />
            自动化、信息化、智能化等一站式解决方案
          </div>
          <div class="font_16">
            CC-1000T智能座舱评测体系由车云研究院与合作伙伴共同研发，体系秉承开放性和延续性等原则，从消<br />
            费者体验角度出发，从智能表现、易用性、外观及科技感、可信赖度和创新等几个维度对车辆的座舱智能<br />
            化程度进行主观体验和评分
          </div>
        </div>
        <div class="content2">
          <div class="meaning_box">
            <div class="meaning_item">
              <div class="meaning_tit">CC</div>
              <div class="meaning_text">CC的含义</div>
              <div class="meaning_desc">
                车云 & 计算+通信<br />
                CC=Car Cloud & Compute+Communication
              </div>
            </div>
            <div class="meaning_item">
              <div class="meaning_tit">1000</div>
              <div class="meaning_text">1000的含义</div>
              <div class="meaning_desc">
                评测体系基础分为1000分，<br />
                另外，对创新项设置不设上限的加分
              </div>
            </div>
            <div class="meaning_item">
              <div class="meaning_tit">T</div>
              <div class="meaning_text">T的含义</div>
              <div class="meaning_desc">
                基于上车实测打分<br />
                基于评分标准及测试用例
              </div>
            </div>
          </div>
        </div>
      </div>
      <div class="section section2">
        <div class="tit">产品服务</div>
        <div class="tabs">
          <div
            :class="['tab', tab_show == 1 ? 'active' : '']"
            @click="tab_show = 1"
          >
            <div class="tab_icon icon_xnjd"></div>
            <div class="tab_tit">性能角度</div>
          </div>
          <div
            :class="['tab', tab_show == 2 ? 'active' : '']"
            @click="tab_show = 2"
          >
            <div class="tab_icon icon_gnjd"></div>
            <div class="tab_tit">功能角度</div>
          </div>
          <div
            :class="['tab', tab_show == 3 ? 'active' : '']"
            @click="tab_show = 3"
          >
            <div class="tab_icon icon_lcjd"></div>
            <div class="tab_tit">用户旅程角度</div>
          </div>
          <div
            :class="['tab', tab_show == 4 ? 'active' : '']"
            @click="tab_show = 4"
          >
            <div class="tab_icon icon_zccx"></div>
            <div class="tab_tit">座舱创新</div>
          </div>
        </div>
        <div class="contents">
          <div class="content" v-show="tab_show == 1">
            <div class="tab_content_left">
              <div class="tab_content_tit">
                CC-1000T智能座舱评测体系<br />
                构建汽车智能座舱用户体验的第三方标尺
              </div>
              <div class="tab_content_tag">性能维度</div>
              <div class="tab_content_desc">
                源于appeals，聚焦用户满意度评价<br />
                评价体系遵循延续性与开放性原则<br />
                满足消费者可感知、可评价、可衡量的最小价值单元
              </div>
            </div>
            <div class="tab_content_right">
              <img
                src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/tab_content_xn.jpg"
                alt=""
              />
            </div>
          </div>
          <div class="content" v-show="tab_show == 2">
            <div class="tab_content_left">
              <div class="tab_content_tit">
                CC-1000T智能座舱评测体系<br />
                构建汽车智能座舱用户体验的第三方标尺
              </div>
              <div class="tab_content_tag">功能维度</div>
              <div class="tab_content_desc">
                站在工程师角度做功能拆分<br />
                贴近车企组织架构提供服务<br />
                从功能诉求角度做竞品分析
              </div>
            </div>
            <div class="tab_content_right">
              <img
                src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/tab_content_gn.jpg"
                alt=""
              />
            </div>
          </div>
          <div class="content" v-show="tab_show == 3">
            <div class="tab_content_left">
              <div class="tab_content_tit">
                CC-1000T智能座舱评测体系<br />
                构建汽车智能座舱用户体验的第三方标尺
              </div>
              <div class="tab_content_tag">用户旅程维度</div>
              <div class="tab_content_desc">
                站在用户的角度聚焦用户核心旅程<br />
                以用户底层需求视角还原用户体验<br />
                八大旅程构建全生命用车周期体验
              </div>
            </div>
            <div class="tab_content_right">
              <img
                src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/tab_content_lt.jpg"
                alt=""
              />
            </div>
          </div>
          <div class="content" v-show="tab_show == 4">
            <div class="tab_content_left">
              <div class="tab_content_tit">
                CC-1000T智能座舱评测体系<br />
                构建汽车智能座舱用户体验的第三方标尺
              </div>
              <div class="tab_content_tag">座舱创新</div>
              <div class="tab_content_desc">
                不设上限<br />
                惊喜+独创+实用<br />
                寻找最具驾驶体验的峰终时刻
              </div>
            </div>
            <div class="tab_content_right">
              <img
                src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/tab_content_cx.jpg"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="section section3">
        <div class="content3">
          <div class="tit">产品优势</div>
          <div class="texts">
            <div class="text">
              <p>
                <span class="color_blue">四</span
                >大维度，<br />200余项专业检测项目
              </p>
            </div>
            <div class="text">
              <p>
                <font class="color_blue">兼</font
                >顾性能评价<br />与核心用车旅途评价
              </p>
            </div>
            <div class="text">
              <p>
                <font class="color_blue">以</font
                >用户底层需求视角<br />还原用户体验
              </p>
            </div>
          </div>
        </div>
        <div class="content4">
          <div class="part part1">
            <div class="part_text">
              <div class="part_text_img">
                <img
                  src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/img_zzjzqjl.jpg"
                  alt=""
                />
              </div>
              <div class="part_text_tit">专注及追求积累</div>
              <div class="part_text_desc">
                <p>
                  测试+研究相结合，关注主客观数据累积，<br />
                  通过智能座舱咨询与研究能力助力体系的先进性
                </p>
                <p>
                  站在未来角度制定现在的标准<br />
                  根据当前的评测研判未来趋势<br />
                  200+主观数据/100+客观数据<br />
                </p>
              </div>
            </div>
            <div class="part_img">
              <img
                src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/zzjzqjl.png"
                alt=""
              />
            </div>
          </div>
          <div class="part part2">
            <div class="part_img">
              <img
                src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/yjdxmlc.png"
                alt=""
              />
            </div>
            <div class="part_text">
              <div class="part_text_img">
                <img
                  src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/img_yjdxmlc.jpg"
                  alt=""
                />
              </div>
              <div class="part_text_tit">严谨的项目流程</div>
              <div class="part_text_desc">
                <p>
                  基于每一个叶子节点的评价模型，结合主客观关联性<br />
                  分析，尽量让每一个主观评价客观化
                </p>
                <p>
                  评测过程流程化<br />
                  评测内容标准化<br />
                  主观评价客观化
                </p>
              </div>
            </div>
          </div>
          <div class="part part3">
            <div class="part_text">
              <div class="part_text_img">
                <img
                  src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/img_bdjhdzncptx.jpg"
                  alt=""
                />
              </div>
              <div class="part_text_tit">不断进化的智能测评体系</div>
              <div class="part_text_desc">
                累计了大量优秀项目案例并验证了设计的价值，<br />
                在不断的探索中总结经验，以结果为导向，不断<br />
                优化测评体系，继续为更多的客户提供有优秀的<br />
                测评数据
              </div>
            </div>
            <div class="part_img">
              <img
                src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/bdjhdzncptx.png"
                alt=""
              />
            </div>
          </div>
        </div>
      </div>
      <div class="section section4">
        <div class="tit">合作客户</div>
        <div class="content5">
          <img
            src="//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/customers.jpg"
            alt=""
          />
        </div>
        <div class="content6">
          <div class="tit">客户现场</div>
          <div class="kh_imgs">
            <template v-for="(item,ind) in khxc.list" :key="ind">
                <template v-if="ind<khxc.cur_show_len">
                    <div class="kh_img">
                        <img :src="item"/>
                    </div>
                </template>
            </template>
            <div class="load_more_kh" v-if="khxc.cur_show_len<khxc.list.length" @click="look_more_kh">
                <p>查看更多<br>现场服务图片</p>
                <div class="look_more_kh_icon"></div>
            </div>
          </div>
        </div>
      </div>
      <div class="section section5">
        <div class="tit">新闻资讯</div>
        <div class="news_content">
          <div class="news">
            <template v-for="(item,ind) in xwzx.list" :key="ind">
                <template v-if="ind<xwzx.cur_show_len">
                    <a :href="item.link" target="_blank" class="news_item">
                        <div class="news_img">
                            <img :src="item.img"/>
                        </div>
                        <div class="news_tit">
                            {{item.tit}}
                        </div>
                    </a>
                </template>
            </template>
          </div>
          <div class="clear_both"></div>
          <div class="look_more" v-if="xwzx.cur_show_len<xwzx.list.length" @click="look_more_xw">查看更多</div>
        </div>
        <div class="content7">
          <div class="bottom_content">
            <div class="bottom_left">
              <div class="bottom_tit">在线反馈</div>
              <div class="bottom_desc">
                留下您的信息，我们将在三个工作日内与您取得联系
              </div>
              <div class="bottom_btn" @click="visitShow = true">马上联系</div>
            </div>
            <div class="bottom_right">
              <div class="ewm_box ewm_left">
                <div class="ewm_tit">官方微信</div>
                <div class="ewm_img">
                  <img src="//www.cheyun.com/static/images/cheyunjun2.png" alt="" />
                </div>
              </div>
              <div class="ewm_box ewm_right">
                <div class="ewm_tit">官方公众号</div>
                <div class="ewm_img">
                  <img src="//www.cheyun.com/static/images/gongzhonghao.png" alt="" />
                </div>
              </div>
            </div>
          </div>
          <div class="bottom_text">
            启程未来科技(北京)有限公司
            <a
              href="//www.beian.gov.cn/portal/registerSystemInfo?recordcode=11010502030076"
              target="_blank"
              >京公网安备11010502030076号 </a
            >|
            <a
              href="//beian.miit.gov.cn/"
              target="_blank"
              >京ICP备13015165号-1 </a
            >
            | 电信与信息服务业务经营许可证：京B2-20181098 | 电话：010-50953476 |
            Copyright ©2013-2022 
          </div>
        </div>
      </div>
    </div>
    <el-dialog v-model="visitShow" width="50%" title="申请访客体验">
      <div>
        您好，我们诚挚的邀请您体验我们的“车云-智能座舱评测云平台”，请您填写下表，我们将由专人与您沟通我们的服务
      </div>
      <div>
        <div class="visitRow">
          <div class="visitLeft">姓名<span>*</span></div>
          <div class="visitRight">
            <input class="visitInput" v-model="visitName" />
          </div>
        </div>

        <div class="visitRow">
          <div class="visitLeft">电话<span>*</span></div>
          <div class="visitRight">
            <input class="visitInput" v-model="visitMobile" />
          </div>
        </div>

        <div class="visitRow">
          <div class="visitLeft">公司<span>*</span></div>
          <div class="visitRight">
            <input class="visitInput" v-model="visitCompany" />
          </div>
        </div>

        <div class="visitRow">
          <div class="visitLeft">部门<span>*</span></div>
          <div class="visitRight">
            <input class="visitInput" v-model="visitDepartment" />
          </div>
        </div>

        <div class="visitRow">
          <div class="visitLeft">职位<span>*</span></div>
          <div class="visitRight">
            <input class="visitInput" v-model="visitPosition" />
          </div>
        </div>

        <div class="visitRow textAreaRow">
          <div class="visitLeft">您的需求信息<span>*</span></div>
          <div class="visitRight">
            <div class="textareaBg">
              <textarea class="visitTextarea" v-model="visitContent"></textarea>
            </div>
          </div>
        </div>
      </div>

      <template #footer>
        <span class="dialog-footer">
          <el-button @click="visitShow = false">取消</el-button>
          <el-button type="primary" @click="submitvisit">提交</el-button>
        </span>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import { onMounted, reactive, ref } from "vue";
import { ElMessage, ElDialog } from "element-plus";
import { visitAdd } from "@/api";
import store from "@/store";
export default {
  components: {
    ElDialog,
  },

  setup() {
    const visitShow = ref(false);
    const visitName = ref("");
    const visitCompany = ref("");
    const visitDepartment = ref("");
    const visitPosition = ref("");
    const visitContent = ref("");
    const visitMobile = ref("");
    let visitSending = 0;
    const submitvisit = () => {
      if (visitSending == 0) {
        if (visitName.value.trim() == "") {
          ElMessage.warning("请填写姓名！");
          return;
        }
        if (visitMobile.value.trim() == "") {
          ElMessage.warning("请填写电话！");
          return;
        }
        if (visitCompany.value.trim() == "") {
          ElMessage.warning("请填写公司！");
          return;
        }
        if (visitDepartment.value.trim() == "") {
          ElMessage.warning("请填写部门！");
          return;
        }
        if (visitPosition.value.trim() == "") {
          ElMessage.warning("请填写职位！");
          return;
        }
        if (visitContent.value.trim() == "") {
          ElMessage.warning("请填写您的需求信息！");
          return;
        }
        visitSending = 1;
        visitAdd({
          visitName: visitName.value,
          visitCompany: visitCompany.value,
          visitContent: visitContent.value,
          visitMobile: visitMobile.value,
          visitDepartment: visitDepartment.value,
          visitPosition: visitPosition.value,
        }).then((res) => {
          visitSending = 0;
          if (res.code == 200) {
            ElMessage.success("提交成功!");
            visitName.value = "";
            visitCompany.value = "";
            visitContent.value = "";
            visitMobile.value = "";
            visitDepartment.value = "";
            visitPosition.value = "";
            visitShow.value = false;
          } else {
            ElMessage.error(res.message || "提交失败!");
          }
        });
      }
    };

    const tab_show = ref(1);
    const fixed_show = ref(1);
    onMounted(() => {
      document
        .querySelector(".container")
        .addEventListener("scroll", function (e) {
          if (e.target.scrollTop > 10) {
            fixed_show.value = 2;
          } else {
            fixed_show.value = 1;
          }
        });
    });
    const scrollToView = (num) => {
      var anchor = document.querySelector(".section" + num);
      document.querySelector(".container").scrollTo({
        top: anchor.offsetTop - 82,
        behavior: "smooth",
      });
    };

    const khxc = reactive({
        cur_show_len:4,
        list:[
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/1.png",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/2.png",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/3.png",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/4.png",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/5.png",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/6.jpg",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/7.jpg",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/8.png",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/9.png",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/10.png",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/11.png",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/12.png",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/13.png",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/14.png",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/15.jpg",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/16.jpg",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/17.jpg",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/18.jpg",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/19.jpg",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/20.jpg",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/21.jpg",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/22.jpg",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/23.jpg",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/24.jpg",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/25.jpg",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/26.jpg",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/27.jpg",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/28.jpg",
            "//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/khxc/29.jpg",
        ]
    })
    const look_more_kh = ()=>{
        khxc.cur_show_len = khxc.cur_show_len+4;
    }
    
    const xwzx = reactive({
        cur_show_len:7,
        list:[
            {
                link:'//mp.weixin.qq.com/s/nCgFAT4ef4h1x6pu0podEw',
                tit:'灵魂五问，CC-1000T智能座舱评测体系答疑',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/1.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/34011',
                tit:'【CC-1000T智能座舱评测之理想ONE】理想ONE的智能化足够理想吗？',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/2.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/34100',
                tit:'【CC-1000T智能座舱评测之广汽新能源Aion S】魅Evo530的智能化水平如何？',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/3.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/34745',
                tit:'我问了NOMI几十个问题，你猜它能不能对答如流？丨CC-1000T智能座舱评测',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/4.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/35301',
                tit:'软硬件一体+自主研发，这款中国品牌汽车令人刮目相看丨CC-1000T智能座舱评测',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/5.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/35605',
                tit:'当旋转屏遇上气泡式UI设计，碰撞出的EX6 Plus是否别具一格？丨CC-1000T智能座舱评测',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/6.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/34853',
                tit:'科技测测看丨新迈腾，合资品牌中的“特斯拉”',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/7.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/35707',
                tit:'东风风神奕炫，一个高性价比的惊喜之作丨CC-1000T智能座舱评测',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/8.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/35755',
                tit:'大众威然，谁说MPV不智能？丨CC-1000T智能座舱评测',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/9.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/35968',
                tit:'“辛巴”来了，全新ES8智能座舱到底有哪些升级？丨CC-1000T智能座舱评测',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/10.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/36357',
                tit:'燃油车同样可以高智能，不信你看这辆车丨CC-1000T智能座舱评测',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/11.jpg"
            },
            {
                link:'//mp.weixin.qq.com/s/q32J_QFlwtiI-4uBOhLEug',
                tit:'进击的领克05，软硬件齐升级，GKUI再演化丨CC-1000T智能座舱评测',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/12.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/36995',
                tit:'Plus加足料，荣威RX5 Plus能否引领“国潮”？丨CC-1000T智能座舱评测',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/13.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/37339',
                tit:'体验瑕不掩瑜，能帮你呼救的哪吒U丨CC-1000T智能座舱评测',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/14.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/37747',
                tit:'小鹏G3尚能战否？丨CC-1000T智能座舱评测',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/15.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/37881',
                tit:'传统车企里的新势力，与全车人智能交互的ARCFOX极狐αT丨CC-1000T智能座舱评测',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/16.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/43762',
                tit:'首创用车场景专业测试体系 MARVEL R智能座舱能力一目了然 | CC-1000T智能座舱评测',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/17.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/45444',
                tit:'“华为智选”招牌能给赛力斯SF5什么惊喜？ | CC-1000T智能座舱评测创新甄选',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/18.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/35758',
                tit:'车上那些让你“哇哦”的功能，智能汽车惊喜创新TOP20',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/19.jpg"
            },
            {
                link:'//www.cheyun.com/articleDetail/45475',
                tit:'双屏合一的宝骏KiWi EV 如何诠释智能 | CC-1000T智能座舱评测创新甄选',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/20.jpg"
            },
            {
                link:'//mp.weixin.qq.com/s/g1clLD152QNWSDJjHPRNXw',
                tit:'三块大屏的零跑C11 如何玩转智能 | CC-1000T智能座舱创新项评测',
                img:"//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/news/21.jpg"
            }
        ]
    })
    const look_more_xw = ()=>{
        xwzx.cur_show_len = xwzx.cur_show_len+5;
    }

    let loginInfo = reactive(null);
    loginInfo = store.checkLogin();
    return {
      visitShow,
      visitName,
      visitCompany,
      visitContent,
      visitDepartment,
      visitPosition,
      visitMobile,
      submitvisit,
      tab_show,
      fixed_show,
      scrollToView,
      khxc,
      look_more_kh,
      xwzx,
      look_more_xw,
      loginInfo
    };
  },
};
</script>

<style lang="less" scoped>
.container {
  width: 100%;
  height: 100%;
  overflow-y: auto;
  padding-top: 82px;
  .fixed_top1 {
    width: 106px;
    height: 155px;
    background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/fixed_top.png)
      no-repeat;
    background-size: 100%;
    position: fixed;
    top: 600px;
    right: 85px;
    z-index: 1;
  }
  .fixed_top2 {
    width: 347px;
    height: 55px;
    background: #6b72f8;
    box-shadow: 0px 5px 12px 1px rgba(126, 117, 181, 0.28);
    border-radius: 100px 0px 0px 100px;
    font-size: 21px;
    font-weight: 400;
    text-align: center;
    color: #ffffff;
    line-height: 55px;
    letter-spacing: 1px;
    position: fixed;
    top: 600px;
    right: 0px;
    z-index: 1;
  }
}
.header {
  position: fixed;
  top: 0;
  z-index: 1;
  min-width: 1200px;
  width: 100%;
  height: 82px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  background: #fff;
  box-shadow: 0px 2px 14px 0px rgba(125, 167, 226, 0.26);
  .head_left {
    display: flex;
    align-items: center;
    padding-left: 65px;
    .logo {
      width: 62px;
      height: 34px;
      background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/logo.png)
        no-repeat;
      background-size: 100%;
    }
    .row_line {
      width: 17px;
      height: 3px;
      background: rgba(97, 113, 164, 0.19);
      border-radius: 2px;
      margin: 0 16px 0 20px;
    }
    .logo_text {
      font-size: 18px;
      font-weight: bold;
      color: #6171a4;
    }
  }
  .head_right {
    display: flex;
    align-items: center;
    padding-right: 36px;
    .head_links {
      display: flex;
      align-items: center;
      .head_link {
        font-size: 15px;
        font-weight: 500;
        color: #6171a4;
        margin-right: 35px;
        cursor: pointer;
      }
    }
    .head_login {
      width: 96px;
      height: 32px;
      background: #587eff;
      border-radius: 16px;
      margin-right: 32px;
      line-height: 32px;
      font-size: 15px;
      font-weight: 500;
      color: #ffffff;
      text-align: center;
      text-decoration: none;
      cursor: pointer;
      &.head_logined{
        background: #ff6a00;
      }
    }
    .head_form {
      width: 149px;
      height: 32px;
      background: #eceff5;
      border-radius: 16px;
      line-height: 32px;
      font-size: 15px;
      font-weight: 500;
      color: #6171a4;
      text-align: center;
      cursor: pointer;
    }
  }
}
.main {
  width: 100%;
  min-width: 1200px;
  .section {
    .tit {
      font-size: 36px;
      font-weight: 500;
      color: #485786;
      line-height: 50px;
      letter-spacing: 2px;
      text-align: center;
    }
  }
  .section1 {
    .banner {
      width: 100%;
      height: auto;
      img {
        display: block;
        width: 100%;
        height: auto;
      }
    }
    .content1 {
      margin: 0 auto;
      padding: 80px 0;
      text-align: center;
      .font_27 {
        font-size: 27px;
        color: #485786;
        line-height: 38px;
        letter-spacing: 1px;
      }
      .font_16 {
        font-size: 16px;
        color: #909bbc;
        line-height: 25px;
        letter-spacing: 1px;
        margin: 60px auto 0;
      }
    }
    .content2 {
      height: 236px;
      background: #f8f9fc;
      .meaning_box {
        display: flex;
        width: 1200px;
        margin: 0 auto;
        justify-content: space-between;
        align-items: center;
        text-align: center;
        .meaning_item {
          width: 350px;
          padding-top: 43px;
          position: relative;
          .meaning_tit {
            height: 76px;
            line-height: 76px;
            font-size: 100px;
            font-weight: bold;
            color: #587eff;
            opacity: 0.06;
          }
          .meaning_text {
            position: absolute;
            top: 43px;
            left: 50%;
            transform: translate(-50%);
            height: 76px;
            line-height: 76px;
            font-size: 27px;
            font-weight: 600;
            color: #587eff;
            letter-spacing: 1px;
          }
          .meaning_desc {
            font-size: 16px;
            font-weight: 400;
            color: #485786;
            line-height: 26px;
            letter-spacing: 1px;
            margin-top: 20px;
            white-space: nowrap;
          }
        }
      }
    }
  }
  .section2 {
    padding-top: 85px;
    .tabs {
      height: 170px;
      display: flex;
      justify-content: space-between;
      width: 1040px;
      margin: 40px auto 0;
      border-bottom: solid 4px #f5f8ff;
      .tab {
        width: 158px;
        height: 170px;
        cursor: pointer;
        &.active {
          border-bottom: solid 4px #5079f2;
          .tab_tit {
            color: #5079f2;
          }
        }
        .tab_icon {
          width: 128px;
          height: 128px;
          margin: 0 auto;
          background-size: 128px;
          background-repeat: no-repeat;
          background-position: center center;
          &.icon_xnjd {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/xnjd.png);
          }
          &.icon_gnjd {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/gnjd.png);
          }
          &.icon_lcjd {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/lcjd.png);
          }
          &.icon_zccx {
            background-image: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/zccx.png);
          }
        }
        .tab_tit {
          height: 32px;
          font-size: 24px;
          font-weight: 400;
          color: #6171a4;
          line-height: 24px;
          text-align: center;
        }
      }
    }
    .contents {
      .content {
        width: 1075px;
        height: 400px;
        margin: 0 auto;
        display: flex;
        justify-content: space-between;
        align-items: center;
        .tab_content_left {
          .tab_content_tit {
            font-size: 27px;
            font-weight: 500;
            color: #6171a4;
            line-height: 40px;
            letter-spacing: 1px;
          }
          .tab_content_tag {
            display: inline-block;
            padding: 0 20px;
            height: 33px;
            border-radius: 6px;
            border: 1px solid #a3acca;
            font-size: 18px;
            color: #6171a4;
            line-height: 33px;
            letter-spacing: 1px;
            margin-top: 24px;
            text-align: center;
          }
          .tab_content_desc {
            font-size: 16px;
            font-weight: 400;
            color: #6171a4;
            line-height: 26px;
            letter-spacing: 1px;
            margin-top: 33px;
            padding-left: 25px;
            position: relative;
            &::before {
              content: "";
              width: 1px;
              height: 85%;
              background: #a3acca;
              position: absolute;
              top: 50%;
              left: 0;
              transform: translateY(-50%);
            }
          }
        }
        .tab_content_right {
          width: 520px;
          height: 233px;
          img {
            display: block;
            margin: 0 auto;
            width: auto;
            height: 100%;
          }
        }
      }
    }
  }
  .section3 {
    .content3 {
      height: 341px;
      background: rgba(248, 249, 252, 0.71);
      padding-top: 43px;
      .texts {
        width: 1113px;
        margin: 45px auto 0;
        display: flex;
        justify-content: space-between;
        .text {
          width: 359px;
          height: 147px;
          border-radius: 25px;
          border: 1px solid #d6d9e2;
          display: flex;
          align-items: center;
          font-size: 18px;
          font-weight: 400;
          line-height: 25px;
          display: flex;
          justify-content: center;
          align-items: center;
          p {
            text-align: center;
            color: #485786;
            .color_blue {
              color: #5079f2;
            }
          }
        }
      }
    }
    .content4 {
      padding: 80px 0 0;
      .part {
        margin: 0 auto;
        width: 1140px;
        display: flex;
        justify-content: space-between;
        align-items: flex-end;
        .part_text {
          .part_text_img {
            margin: 0 auto;
            img {
              width: 100%;
              height: 100%;
            }
          }
          .part_text_tit {
            margin-top: 32px;
            font-size: 22px;
            font-weight: 500;
            color: #6171a4;
            line-height: 30px;
            text-align: center;
          }
          .part_text_desc {
            margin-top: 32px;
            font-size: 16px;
            font-weight: 400;
            color: #6171a4;
            line-height: 26px;
            text-align: center;
            p {
              margin-bottom: 13px;
            }
          }
        }
        .part_img {
          width: 654px;
          img {
            width: 100%;
            height: auto;
          }
        }
        &.part1 {
          .part_text_img {
            width: 214px;
            height: 214px;
          }
        }
        &.part2 {
          margin-top: 115px;
          .part_text_img {
            width: 190px;
            height: 133px;
          }
        }
        &.part3 {
          margin-top: 175px;
          margin-bottom: 160px;
          .part_text_img {
            width: 128px;
            height: 116px;
          }
          .part_text_desc {
            padding-bottom: 20px;
          }
        }
      }
    }
  }
  .section4 {
    .content5 {
      margin-top: 30px;
      padding: 47px 0;
      width: 100%;
      background: #f8f9fc;
      img {
        display: block;
        width: 1135px;
        height: 443px;
        margin: 0 auto;
      }
    }
    .content6 {
      padding-top: 89px;
      .kh_imgs {
        width: 1131px;
        margin: 89px auto 100px;
        display: flex;
        flex-wrap: wrap;
        position: relative;
        .kh_img {
          width: 276px;
          height: 184px;
          margin-right: 9px;
          margin-bottom: 9px;
          background: #ccc;
          &:nth-child(4n) {
            margin-right: 0;
          }
          img {
            width: 100%;
            height: 100%;
            object-fit: cover;
          }
        }
        .load_more_kh{
            width: 276px;
            height: 184px;
            padding-top: 54px;
            background: rgba(0, 0, 0, .7);
            font-size: 18px;
            font-weight: 400;
            color: #FFFFFF;
            text-align: center;
            line-height: 25px;
            position: absolute;
            right: 0;
            bottom: 9px;
            cursor: pointer;
            .look_more_kh_icon{
                width: 28px;
                height: 28px;
                margin: 10px auto 0;
                background: url(//cheyun-img.oss-cn-beijing.aliyuncs.com/cy_report_img/introduct/next.png) no-repeat;
                background-size: 100%;
            }
        }
      }
    }
  }
  .section5 {
    .news_content {
      width: 1130px;
      margin: 18px auto 0;
      .news {
        width: 1150px;
        height: auto;
        .news_item {
          display: block;
          width: 210px;
          height: 140px;
          margin-right: 20px;
          margin-bottom: 13px;
          background: #ccc;
          border-radius: 8px;
          overflow: hidden;
          float: left;
          position: relative;
          .news_img {
            width: 100%;
            height: 100%;
            img {
              width: 100%;
              height: 100%;
              object-fit: cover;
            }
          }
          .news_tit {
            width: 100%;
            height: 28px;
            background: #323232;
            font-size: 14px;
            color: #ffffff;
            line-height: 28px;
            text-align: center;
            padding: 0 10px;
            position: absolute;
            left: 0;
            bottom: 0;
            overflow: hidden;
            text-overflow: ellipsis;
            word-break: break-all;
            display: -webkit-box;
            -webkit-line-clamp: 1;
            -webkit-box-orient: vertical;
          }
          &:nth-child(1) {
            width: 440px;
            height: 293px;
            .news_tit {
              height: 36px;
              line-height: 36px;
            }
          }
        }
      }
      .clear_both {
        width: 0;
        height: 0;
        clear: both;
      }
      .look_more {
        margin: 60px auto 0;
        width: 272px;
        height: 44px;
        line-height: 44px;
        border-radius: 9px;
        border: 1px solid #d4d9e8;
        font-size: 18px;
        font-weight: bold;
        color: #6171a4;
        text-align: center;
        cursor: pointer;
      }
    }
    .content7 {
      margin-top: 101px;
      background: #f8f9fc;
      padding-bottom: 22px;
      .bottom_content {
        display: flex;
        justify-content: space-between;
        width: 1109px;
        margin: 0 auto;
        padding-top: 82px;
        .bottom_left {
          height: 198px;
          .bottom_tit {
            height: 45px;
            font-size: 32px;
            font-weight: 600;
            color: #485786;
            line-height: 45px;
          }
          .bottom_desc {
            margin-top: 4px;
            height: 24px;
            font-size: 18px;
            color: #6171a4;
            line-height: 24px;
            letter-spacing: 1px;
          }
          .bottom_btn {
            margin-top: 57px;
            width: 180px;
            height: 47px;
            background: #485786;
            border-radius: 28px;
            font-size: 20px;
            color: #ffffff;
            text-align: center;
            line-height: 47px;
            letter-spacing: 1px;
            cursor: pointer;
          }
        }
        .bottom_right {
          width: 413px;
          height: 198px;
          background: #ffffff;
          box-shadow: 0px 4px 16px 0px rgba(71, 77, 102, 0.03);
          border-radius: 15px;
          padding: 10px 58px;
          display: flex;
          justify-content: space-between;
          .ewm_box {
            width: 116px;
            .ewm_tit {
              height: 44px;
              font-size: 18px;
              color: #6171a4;
              line-height: 44px;
              letter-spacing: 1px;
              text-align: center;
            }
            .ewm_img {
              width: 116px;
              height: 116px;
              overflow: hidden;
              img {
                width: 100%;
                
              }
            }
          }
        }
      }
      .bottom_text {
        margin-top: 61px;
        font-size: 12px;
        font-weight: 400;
        color: #485786;
        line-height: 17px;
        text-align: center;
        a {
          color: #485786;
          text-decoration: none;
        }
      }
    }
  }
}
.visitTextarea {
  width: 100%;
  height: 100%;
  resize: none;
  padding: 10px;
  background-color: rgb(246, 249, 253);
  border-color: rgb(246, 249, 253);
  outline: none;
}
.textareaBg {
  height: 150px;
  background-color: rgb(246, 249, 253);
  margin-bottom: 10px;
}
.visitLeft {
  width: 20%;
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.visitLeft span {
  color: red;
  margin: 5%;
}
.visitRight {
  width: 80%;
}
.visitInput {
  width: 100%;
  height: 100%;
  padding: 10px;
  background-color: rgb(246, 249, 253);
  border: none;
  outline: none;
}
.visitRow {
  height: 40px;
  display: flex;
  margin-top: 25px;
}
.applyBtn {
  margin-top: 20px;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  color: #48498d;
  cursor: pointer;
}
.textAreaRow {
  height: 150px;
}
</style>